module.exports = __webpack_public_path__ + "assets/minusSignBig-56f850.svg";